import { FilterSearchingBaseViewModel, PagingResultsViewModel } from 'src/app/components/core/_infrastructure/types/common';

export class AlertaProductoRechazadoViewModel {
    public IdSolicitud: number;
    public Codigo: string;
}

export class AlertaProductoRechazadoItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: AlertaProductoRechazadoItemViewModel[];
}

export class AlertaProductoRechazadoItemViewModel {
    public IdSolicitud: number;
    public IdProductoSolicitud: number;
    public Codigo: string;
    public FechaEnvio: Date;
    public NifImportador: string;
    public IdPaisOrigen: number;
    public IdPaisOrigenDescripcion: string;
    public IdEspecie: number;
    public CodigoEppo: string;
    public IdGrupo: number;
    public IdGrupoDescripcion: string;
    public IdForma: number;
    public IdFormaDescripcion: string;
    public NombreCientifico: string;
    public NombreComun: string;
    public Peso: number;
}

export class FilterSearchingAlertaProductoRechazadoViewModel extends FilterSearchingBaseViewModel {
    public IdEspecie: number;
    public CodigoEppo: string;
    public IdGrupo: number;
    public IdForma: number;
    public NombreCientifico: string;
    public NombreComun: string;
    public Codigo: string;
    public FechaEnvio: Date;
    public NifImportador: string;
    public IdPaisOrigen: number;
}
